import UmlShape from './UmlShape';
import { ShapeGeoBuilder } from '@jxUml';

// Composite-pattern: shape die andere UmlShape-instanties bevat.
// LET OP: alleen voor shapes die echt genest kunnen worden (Package bevat Class,
// evt. geneste Package). UmlClassShape extendt dit NIET meer, zie toelichting
// bij UmlClassShape.js — members zijn geen UmlShape-children, dus horen niet
// in dezelfde addChild()-contract als hier.
class UmlCompositeShape extends UmlShape {
  constructor(id, x, y, w, h) {
    super(id, x, y, w, h);
    this.children = [];
  }

  addChild(childShape) {
    childShape.parentId = this.id;
    // Kind moet altijd boven zijn eigen container renderen, anders ligt de
    // (evt. transparante) package-laag visueel/klik-technisch bovenop de class.
    childShape.zIndex = this.zIndex + 1;
    this.children.push(childShape);
  }

  removeChild(childId) {
    this.children = this.children.filter(function filterOutChild(child) {
      return child.id !== childId;
    });
  }

  containsShape(shape) {
    return this.containsPoint(shape.x, shape.y) && this.containsPoint(shape.x + shape.w, shape.y + ShapeGeoBuilder.effectiveHeight(shape));
  }
}

export default UmlCompositeShape;
